import project from '@nextories/vue-tasks/src/i18n/langs/fr/project';

export default {
  ...project,
  helper: {
    nextAction: 'Prochaine action : ',
    offersReady: {
      coordNotSent: {
        status: 'Devis indiqués comme prêts',
        action: '@:project.helper.nextAction En attente du retour de la coordination pour présentation des offres au client.',
      },
      notSent: {
        action: '@:project.helper.nextAction Transmettre les offres au GC pour sélection',
      },
      notSelected: {
        status: 'Devis transmis à {partnerAccount} pour sélection',
        action: '@:project.helper.nextAction En attente du retour de {partnerAccount} pour sélection du (des) devis à présenter au client.',
      },
      partnerSelectionDone: {
        status: 'Offres sélectionnées par {partnerAccount}',
      },
      coordSelectionDone: {
        status: 'Offres validées par la coordination',
      },
      defaultAction: {
        action: '@:project.helper.nextAction Contacter le client pour lui présenter les devis',
      },
    },
    offersNotReady: {
      action: '@:project.helper.nextAction Informer la coordination une fois les devis reçus',
    },
    demCompSent: {
      prebookWait: {
        status: 'Demande de pré-réservation de {mover}',
        action: '@:project.helper.nextAction En attente de la validation de la pré-réservation par {mover}',
      },
      prebooked: {
        notOk: {
          status: 'Demande de pré-réservation de {mover}',
          action: '@:project.helper.nextAction En attente de la validation de la pré-réservation par la coordination',
        },
        ok: {
          status: 'Devis de {mover} pré-réservé jusqu\'au {date}',
          action: '@:project.helper.nextAction Relancer le client pour signature du devis avant expiration de la pré-réservation ({date})',
        },
        partnerOk: {
          action: '@:project.helper.nextAction En attente de la validation du dossier par {partnerAccount}',
        },
      },
      repValidForPcd: {
        status: 'Devis de {mover} validé par {partnerAccount}',
        action: '@:project.helper.nextAction Relancer le client pour signature du devis avant expiration de la pré-réservation ({date})',
      },
      repFailure: {
        status: 'Mise en relation refusée par {mover}',
      },
      action: '@:project.helper.nextAction Relancer le client pour pré-réservation d\'une offre',
    },
    demOption: {
      status: 'Option posée sur {mover} {dateOption}',
      action: '@:project.helper.nextAction En attente mise en relation par la coordination',
      notSignedExists: {
        action: '@:project.helper.nextAction Relancer le client pour signature du devis',
      },
    },
    demSuccess: {
      status: 'Dossier accepté par {mover}',
      action: '@:project.helper.nextAction Relancer le client pour signature du devis',
    },
  },
};
